/**
 * Created by lk on 17/6/4.
 */
import axios from "axios";
import https from "../../utils/http";
import { getToken, getAdminId } from "../../utils/auth";
let http = https.https;
// 获取信息
export function userInfo(id, token) {
    return axios({
        url: http + "/auth/login/userInfo",
        method: "get",
        params: {
            ADMIN_ID: id,
            ADMIN_TOKEN: token
        },
        data: {
            ADMIN_TOKEN: token,
            ADMIN_ID: id
        },
        headers: { "X-Adminid": id, "X-Token": token }
    });
}

export function loginName(userName, pwd) {
    let querys = { userName, pwd };
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: http + "/auth/login/index",
        method: "post",
        data: querys
    });
}

export function logout(uid, token) {
    let querys = { uid, token };
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: http + "/auth/login/out",
        method: "post",
        data: querys
    });
}

export function password(data) {
    let querys = JSON.parse(JSON.stringify(data));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: http + "/auth/login/password",
        method: "post",
        data: querys
    });
}
